/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { FC } from 'react';
import { StyledPolicy } from './PrivacyPolicyText.styles';
import './PrivacyPolicyText.css';

const PrivacyPolicyText: FC = () => {
  return (
    <StyledPolicy>
      <div>
        <p className="c17">
          <span className="c2">PLATFORMOS TAISYKLĖS</span>
        </p>
        <ol className="c0 lst-kix_p4jwollyg6go-0 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c2">KAS MES ESAME?</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Hikos (www.hikos.eu) yra platforma (toliau –{' '}
            </span>
            <span className="c6">Hikos</span>
            <span className="c10">&nbsp;arba </span>
            <span className="c6">Platforma</span>
            <span className="c10">
              ), skirta žemės ūkio veiklų ir resursų valdymui. Platformos nariai
              – įmonių atstovai, ūkininkai ar ūkių valdytojai joje gali matyti
              savo laukus, planuoti darbus, kurti sėjos, tręšimo, kūlimo,
              purškimo ir pan. užduotis kitiems Platformos nariams, pavyzdžiui,
              agronomams, rangovams, konsultantams (toliau–{' '}
            </span>
            <span className="c6">Nariai</span>
            <span className="c1">). </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Platformą valdo ir Platformos paslaugas teikia UAB Hikos,
              juridinio asmens kodas 306032221, registruotos buveinės adresas
              Vito Gerulaičio g. 10-101, LT-08200 Vilnius, Lietuva (toliau –{' '}
            </span>
            <span className="c6">mes </span>
            <span className="c10">arba</span>
            <span className="c6">&nbsp;Platformos savininkas</span>
            <span className="c1">
              ). Su mumis susisiekti galite šiais kontaktais:
            </span>
          </li>
        </ol>
        <p className="c15">
          <span className="c1">
            Tel.: +370 652 88874
            <br />
            El. paštas: info@hikos.eu
            <br />
            Adresas: Vito Gerulaičio g. 10-101, LT-08200 Vilnius
          </span>
        </p>
        <ol className="c0 lst-kix_p4jwollyg6go-1" start={3}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Mes teikiame Platformos paslaugas, t.&nbsp;y., veikdami kaip
              tarpininkas, suteikiame galimybę Nariams valdyti resursus,
              suteikdami jiems informaciją iš integruotų sistemų (klimato
              stebėjimo, palydovų, GPS, žemės ūkio technikos ir kt.) ir/ ar
              leisdami perkelti duomenis iš trečiųjų šalių, visus duomenis
              apibendrinti ir analizuoti, bei suteikdami galimybę (jiems taip
              nusprendus savo nuožiūra) suteikti prieigą prie šių duomenų
              kitiems Nariams, ar naudojantis Platformos funkcionalumais
              perduoti duomenis valstybės ar savivaldos institucijoms.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Platformos savininkas užtikrins, jog Platforma būtų pasiekiama
              Nariams 99 procentus laiko per metus.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Mes teikiame Platformos paslaugas išskirtinai tik verslo
              subjektams (B2B) ir Nariais nėra ir negali tapti vartotojai
            </span>
            <sup className="c10 c22">
              <a href="#ftnt1" id="ftnt_ref1">
                [1]
              </a>
            </sup>
            <span className="c1">
              . Hikos nėra atsakinga už tai, kaip Nariai naudoja Platformoje
              gautus duomenis, arba už patarimus ar informaciją, kurią Nariai
              teikia vieni kitiems.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jūsų pateiktus duomenis mes tvarkome Privatumo politikoje
              numatytais tikslais ir tvarka.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={2}>
          <li className="c3 li-bullet-0">
            <span className="c2">KĄ REIŠKIA ŠIOS TAISYKLĖS?</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Taisyklės sudaro susitarimą tarp mūsų (Platformos savininko) ir
              Jūsų, pagal kurį mes suteiksime Jums galimybę tapti Platformos
              Nariu.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jūs turite teisę naudotis Platforma tik tuo atveju, jei pagal
              galiojančius įstatymus galite sudaryti įpareigojančią sutartį su
              Platformos savininku, ir tik tuo atveju, jei laikysitės šių
              Taisyklių bei galiojančių įstatymų. Jeigu Jums mažiau nei
              18&nbsp;metų, naudotis Platforma negalite. Registruodamiesi
              Platformoje, Jūs patvirtinate, jog esate 18 metų
              ir&nbsp;/&nbsp;arba turite įgaliojimus Platformoje atstovauti Narį
              (juridinį asmenį).
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={3}>
          <li className="c3 li-bullet-0">
            <span className="c2">NARIO APLINKA IR JOS SUTEIKIAMOS TEISĖS</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Norėdamas tapti Platformos Nariu, turite pateikti Platformoje
              prašomą tikslią ir išsamią informaciją apie Jūsų valdomą ar
              atstovaujamą įmonę ar ūkį, susipažinti su šiomis Taisyklėmis ir
              Privatumo politika bei Platformoje pasirinkti prenumeratos
              versiją.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Tam, kad galėtumėte naudotis Platformos paslaugomis ir
              funkcionalumais, Jūs turite susikurti Nario aplinką Platformoje
              (toliau –{' '}
            </span>
            <span className="c6">Aplinka</span>
            <span className="c1">).</span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Nariai yra atsakingi už visus per Jų Aplinką atliekamus veiksmus,
              todėl turi pasirūpinti savo slaptažodžių ar kitų duomenų, kuriais
              galima prisijungti prie Nario Aplinkos, saugumu. Vis dėlto, jei
              Narys pastebi, jog kažkas neleistinai naudojasi Jo Aplinka, Jis
              turi nedelsdamas susisiekite su Platformos savininku.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Narys Aplinkoje gali keisti kai kuriuos duomenis savo nuožiūra,
              redaguoti, atnaujinti, papildyti informaciją apie save ar savo
              veiklą. Įvesdamas duomenis, Narys privalo užtikrinti, kad
              nepažeidžia trečiųjų asmenų teisių ir/ar teisėtų interesų ir/ar
              teisės aktų reikalavimų (pavyzdžiui, įkelia tik savo nuotrauką
              arba kitą nuotrauką ar vaizdą, jeigu turi teisę tai daryti).
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Platforma pati neredaguoja Nario pateiktos ar teikiamos
              informacijos ir netikrina jos teisingumo, atitikties teisės aktų
              reikalavimams. Narys yra atsakingas už jo Platformoje skelbiamą
              informaciją, atliekamus veiksmus bei teikiamus patarimus ar
              paslaugas.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Narys prie savo Aplinkos Platformoje gali suteikti prieigą
              (pridėti) kelis atstovus, pavyzdžiui, darbuotojus, konsultantus
              (toliau –{' '}
            </span>
            <span className="c6">Vartotojai</span>
            <span className="c10">
              ). Registracijos metu Nario sukurta Aplinka turi administratoriaus
              teises. Narys prie savo Aplinkos pridėdamas Vartotoją nustato
              kokius leidimus atlikti veiksmus Nario Aplinkoje jam suteikia.{' '}
            </span>
            <span className="c10 c26">
              Narys yra atsakingas už jo Paskyroje pridėtų Vartotojų Platformoje
              atliekamus veiksmus ir elgesį Platformoje. Taip pat Narys turo
              informuoti Vartotojus ar savo darbuotojus apie jų asmens duomenų
              perdavimą ir tvarkymą Platformoje (pavyzdžiui, darbuotojų
              informavimas apie jų judėjimo (GPS) duomenų perdavimą).
            </span>
            <span className="c1">&nbsp;</span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Narys Platformoje gali pasidalinti savo Aplinkos informacija su
              kitais Nariais, suteikdamas jiems pasirinktas teises.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Narys Platformoje gali matyti informaciją apie savo ūkį iš
              palydovų bei ūkyje įdiegtų įrenginių, pavyzdžiui, pagal žemės ūkio
              technikos GPS duomenis, gauti pasiūlymus iš kitų Narių dėl ūkio
              veiklos gerinimo, procesų optimizavimo, matyti informaciją apie
              kitų Narių ar Vartotojų atliktas užduotis, paskirti jiems
              užduotis, gauti Narių pasiūlymus, persiųsti savo Aplinkos
              informaciją ir kt.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Narys, naudodamasis Platforma, informaciją iš savo Aplinkos gali
              perduoti valstybės ar savivaldos institucijoms deklaravimo ar
              ataskaitų teikimo tikslais, kredito teikimo įstaigoms ir kt.
              Platforma be Nario sutikimo neperduoda jo Aplinkos duomenų jokioms
              valstybinėms ar savivaldos institucijoms ir/ar kitiems asmenims
              ir/ar nesuteikia prieigos kitiems Nariams ar Vartotojams prie
              Aplinkos.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Nariai už naudojimąsi Platforma turi mokėti metinį mokestį pagal
              pasirinktą prenumeratos planą ir nurodomas sąlygas.{' '}
            </span>
            <span className="c10 c26">
              Platformos teikiamos paslaugos, kurios yra paremtos Hikos gautais
              viešais ir moksliniams tyrimams naudojamais duomenis, yra
              nemokamos.
            </span>
            <span className="c1">&nbsp;</span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Tarp Platformos valdytojo ir Nario sudaroma sutartis laikoma
              sudaryta nuo to momento, kai Narys Platformoje pasirenka
              prenumeratą ir patvirtina, kad susipažino ir sutinka su
              Taisyklėmis bei Privatumo politika, ir galioja neterminuotai.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Narys turi teisę uždaryti savo Aplinką (nutraukti sutartį){' '}
            </span>
            <span className="c7">
              vienašališkai ir nenurodydamas jokių priežasčių, pranešdamas apie
              tai Platformai raštu{' '}
            </span>
            <span className="c10">
              prieš 30 (trisdešimt) kalendorinių dienų. El. pašto adresu
              info@hikos.eu
            </span>
            <span className="c7">
              . Tokiu atveju Aplinka uždaroma nuo minėto
            </span>
            <span className="c10">
              &nbsp;30 (trisdešimt) kalendorinių dienų
            </span>
            <span className="c27 c7">&nbsp;termino pabaigos. </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Nariui uždarius savo Aplinką (nutraukus sutartį) nepasibaigus
              metinės prenumeratos terminui, Nariui yra proporcingai grąžinama
              likusi (nepanaudota) jo metinės prenumeratos mokesčio dalis.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Nariui nesumokėjus metinio prenumeratos mokesčio jo Aplinka yra
              uždaroma.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Uždaryta Nario Aplinka saugoma 4 (keturis) metus, paskui ji yra
              ištrinama. Narys šiuo metu galės prisijungti prie Paskyros, tačiau
              ja galės naudotis tik vėl sumokėjęs metinį prenumeratos mokestį.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={4}>
          <li className="c3 li-bullet-0">
            <span className="c2">INTELEKTINĖ NUOSAVYBĖ</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Platformoje naudojami prekių ženklai ir logotipai, domeno vardas,
              pati Platforma, mobilioji programėlė ir interneto svetainė,
              kurioje ji yra talpinama, o taip pat visi atskiri jų elementai,
              įskaitant tekstus, fotografijas, piešinius ir visą medžiagą,
              esančią Platformoje, mobilioje programėlėje bei interneto
              svetainėje, bet kurio Platformos, mobilios programėlės ar
              interneto svetainės puslapio pateikimas, vaizdas bei dizainas ir
              visos intelektinės nuosavybės teisės į juos išimtinai priklauso
              tik Platformos savininkui ir/ar kitiems asmenims.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Platformos savininkas Jums suteikia neišimtinę, neperleidžiamą,
              ribotą teisę (licenciją) naudotis Platforma, mobiliąja programėle
              ir interneto svetaine ir su jais susijusia intelektine nuosavybe
              išskirtinai Platformos naudojimo šiose Taisyklėse numatyta
              apimtimi tikslais.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jūs įsipareigojate nekopijuoti, nekeisti ar kitaip nenaudoti šių
              intelektinės nuosavybės objektų be atskiro rašytinio teisių
              turėtojo sutikimo.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c10">
              Jūs įsipareigojate nebandyti tirti ar tikrinti bet kurios sistemos
              ar tinklo, naudojamo Platformos teikimui, pažeidžiamumo,
              nepažeisti jokių saugumo ar autentifikavimo priemonių, nebandyti
              iššifruoti, dekompiliuoti (
            </span>
            <span className="c10 c19">reverse engineer</span>
            <span className="c1">
              ), ardyti ar modifikuoti programinės įrangos ar duomenų bazių,
              naudojamų Platformos veikimui.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jūs neturite teisės naudoti Platformos tokiu būdu, kuris gali
              sukelti pavojų Platformos ar su ja susijusios programinės įrangos
              tinkamam veikimui, jos saugumui, vientisumui, ar riboti kitų
              asmenų galimybę pasinaudoti Platforma.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={5}>
          <li className="c3 li-bullet-0">
            <span className="c2">ATSAKOMYBĖ</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Naudodamiesi Platforma, Jūs turite pateikti visą teisingą ir
              išsamią prašomą pateikti informaciją.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jūs esate atsakingi už Jūsų Aplinkos vardo, slaptažodžio ar kitų
              duomenų, leidžiančių prisijungti prie Jūsų Aplinkos Platformoje,
              saugumą. Vis dėlto, jei pastebėjote, jog kažkas neleistinai
              naudojasi Jūsų Aplinkos vardu ir slaptažodžiu, nedelsdami
              susisiekite su Platformos savininku.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Mes turime teisę laikinai sustabdyti Jūsų Aplinkos naudojimą,
              jeigu turime įtarimų, jog kažkas neleistinai naudojasi Jūsų
              Aplinka arba gauname atitinkamus valstybės institucijų ar teismo
              nurodymus.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Mes turime teisę vienašališkai, įspėję Jus prieš 30 (trisdešimt)
              kalendorinių dienų, nutraukti su Jumis sutartį ir visam laikui
              uždaryti (užblokuoti) Jūsų Aplinką, jeigu Jūs pažeidžiate
              Taisyklių nuostatas ir neištaisote pažeidimo per protingą terminą
              nuo mūsų pranešimo.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={6}>
          <li className="c3 c28 li-bullet-0">
            <span className="c2">PAKEITIMAI IR NUTRAUKIMAS</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Mes galime kartas nuo karto dėl svarbių priežasčių (pavyzdžiui,
              teisės aktų pasikeitimo, Platformos veikimo/funkcijų pakeitimo ir
              kt.) keisti šias Taisykles. Jeigu keičiame Taisykles dėl kitų
              priežasčių, apie tokį pakeitimą Jus informuosime iš anksto, prieš
              15&nbsp;(penkiolika) kalendorinių dienų iki pakeitimų
              įsigaliojimo, kad turėtumėte galimybę susipažinti su atnaujintomis
              Taisyklėmis ir nuspręsti dėl tolimesnio naudojimosi Platforma ar
              Aplinkos uždarymo. Naujausia (aktuali) Taisyklių versija visada
              bus matoma ir pasiekiama Platformoje.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-0" start={7}>
          <li className="c3 c28 li-bullet-0">
            <span className="c2">KITOS SĄLYGOS</span>
          </li>
        </ol>
        <ol className="c0 lst-kix_p4jwollyg6go-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Šios Taisyklės yra sudaromos ir turi būti aiškinamos vadovaujantis
              Lietuvos Respublikos įstatymais.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Bet kokie iš šių Taisyklių kylantys arba su jomis susiję ginčai,
              nesutarimai ar pretenzijos, taip pat jų pažeidimo, nutraukimo ar
              galiojimo klausimai yra sprendžiami Lietuvos Respublikos teismuose
              Lietuvos Respublikos įstatymų nustatyta tvarka.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Visi įspėjimai ar kiti pranešimai, susiję su šiomis Taisyklėmis,
              bus pateikiami el.&nbsp;paštu (siunčiant Platformai – Taisyklių
              pradžioje nurodytu el.&nbsp;pašto adresu, siunčiant Jums –
              Aplinkoje nurodytu el.&nbsp;pašto adresu).
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c1">
              Jei kuri nors iš šių Taisyklių nuostatų yra arba tampa visiškai
              arba iš dalies nebegaliojanti, likusių nuostatų galiojimui tai
              įtakos neturi.
            </span>
          </li>
        </ol>
        <p className="c21" id="h.gjdgxs">
          <span className="c1">Taisyklės atnaujintos 2022-05-03</span>
        </p>
        <p className="c5 c13">
          <span className="c2" />
        </p>
        <p className="c9">
          <span className="c11">PRIVATUMO POLITIKA</span>
        </p>
        <p className="c4">
          <span className="c1">
            Mes, UAB Hikos, žinome, kad Jums rūpi, kaip naudojama ir dalijamasi
            Jūsų duomenimis, ir mes į Jūsų privatumą žiūrime atsakingai. Manome,
            kad galime padėti Jums užtikrinti savo gerovę, rūpindamiesi
            Platformoje pateikiamų Jūsų duomenų sauga. Pažadame niekada
            neparduoti Jūsų duomenų ir suteikti Jums skaidrumą apie tai, kaip
            Jūsų duomenys yra naudojami, ir kontrolę, su kuo jais norite
            dalintis. Suprantame, kad, patikėdami mums savo duomenis, priimate
            Jums reikšmingą sprendimą, o šios informacijos apsauga yra svarbi
            mūsų verslo dalis.
          </span>
        </p>
        <p className="c4">
          <span className="c1">
            Šioje Privatumo politikoje vartojamos sąvokos turi Taisyklėse
            numatytą reikšmę.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c2">KĄ REIŠKIA ŠI PRIVATUMO POLITIKA?</span>
          </li>
        </ol>
        <p className="c4">
          <span className="c10">Šioje privatumo politikoje (toliau – </span>
          <span className="c6">Privatumo politika</span>
          <span className="c10">
            ) Jums pateikiame informaciją apie tai, kaip UAB Hikos (toliau –{' '}
          </span>
          <span className="c6">Hikos</span>
          <span className="c1">
            ) tvarko Jūsų asmens duomenis, jums naudojantis Platforma, kuri yra
            pasiekiama kaip mobilioji programėlė ir interneto svetainė ar
            kitomis paslaugomis.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={2}>
          <li className="c3 li-bullet-0">
            <span className="c2">APIE HIKOS</span>
          </li>
        </ol>
        <p className="c4">
          <span className="c10">
            UAB Hikos, juridinio asmens kodas 306032221, buveinės adresas Vito
            Gerulaičio g. 10-101, LT-08200 Vilnius, el.&nbsp;pašto adresas:{' '}
          </span>
          <span className="c7">info@hikos.eu</span>
          <span className="c1">, yra Jūsų asmens duomenų valdytojas.</span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={3}>
          <li className="c3 li-bullet-0">
            <span className="c6">KOKIUS DUOMENIS TVARKO HIKOS?</span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Jums naudojantis Platforma Hikos tvarko šių tipų Jūsų duomenis:
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1 start" start={1}>
          <li className="c3 li-bullet-0">
            <span className="c6">Agro duomenys</span>
            <span className="c10">
              &nbsp;reiškia be kokius žemės ūkio duomenis, kurie yra plačiai
              suprantami žemės ūkio pramonėje, įskaitant, bet neapsiribojant,
              jūsų agronominiais duomenimis, taikymo duomenimis, taip pat
              klimato, derliaus, sąskaitų faktūrų, sėjos, dirvos, mašinų,
              kainodaros, grūdų pardavimo, orų, žemės ūkio produktų ar paslaugų,
              duomenimis, kuriuos naudojate ir perkate iš mūsų ar kitų šalių.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c6">Finansiniai duomenys</span>
            <span className="c1">
              &nbsp;reiškia bet kokią kredito, finansinę ar mokėjimo
              informaciją, įskaitant, bet neapsiribojant, turtą ir
              įsipareigojimus, banko sąskaitų numerius, kredito kortelių
              numerius, kredito istoriją, darbo istoriją, pajamų šaltinius,
              mokėjimų istoriją, mokėjimo nuostatas ir socialinio draudimo
              numerį. Pastaba: Finansiniams duomenims, kuriuos pateikėte arba
              mes surinkome apie Jus iš trečiųjų šalių, susijusių su kredito
              paraiška ar kitais tikslais, gali būti taikomos papildomos juose
              išvardytos sąlygos.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c6">Nario turinys</span>
            <span className="c1">
              &nbsp;reiškia bet kokį ir visą tekstą, grafiką, logotipus,
              įrankius, nuotraukas, vaizdus, iliustracijas, garso ir vaizdo
              įrašus, animaciją, kurį pateikiate naudodamiesi Hikos paslaugomis.
            </span>
          </li>
          <li className="c3 li-bullet-0">
            <span className="c6">Asmens duomenys</span>
            <span className="c1">
              &nbsp;reiškia bet kokią Hikos apie fizinį asmenį renkamą
              informaciją, kuri gali būti panaudota to asmens tapatybei
              nustatyti. Asmens duomenys apima tokią informaciją, kaip asmens
              vardas, pavardė, adresas, nuotrauka ir kt.
            </span>
          </li>
        </ol>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={4}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              KOKIAIS TIKSLAIS JŪSŲ ASMENS DUOMENIS MES RENKAME?
            </span>
          </li>
        </ol>
        <p className="c15">
          <span className="c1">
            Hikos tvarko Jūsų asmens duomenis žemiau nurodomais tikslais:
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={5}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Jūsų Aplinkos Platformoje sukūrimo tikslu
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Jūsų Aplinkos Platformoje sukūrimo tikslu arba Jūsų kaip Nario
            atstovo (Vartotojo) pridėjimo prie Nario aplinkos tikslu Hikos
            tvarko šiuos asmens duomenis: vardas, pavardė, el.&nbsp;pašto
            adresas, slaptažodis, (jeigu Jums taikoma) telefono numeris, šalis,
            rajonas, miestas. Taip pat renkami šie duomenys (jeigu Jums
            taikoma): ūkininko numeris, valdos numeris, purškimo pažymėjimo
            numeris, PVM mokėtojo kodas, purškimo pažymėjimo Nr. Šie asmens
            duomenys yra tvarkomi sutarties sudarymo ir vykdymo pagrindu bei yra
            saugomi 4 (ketverius) metus nuo Nario Aplinkos uždarymo dienos. .
          </span>
        </p>
        <p className="c16">
          <span className="c1">
            Naudodamiesi Platforma, aukščiau nurodomus asmens duomenis,
            Platformos naudotojo duomenis, agro ir finansinius duomenis savo
            pasirinkimu galite atskleisti kitiems Platformos naudotojams bei
            valstybės ar savivaldos institucijoms. Hikos savo iniciatyva tokių
            duomenų be Jūsų leidimo neperduos kitiems nariams ar jokioms
            institucijoms ar įstaigoms. Jūs nusprendžiate, kam ir kokius
            duomenis atskleisti, naudojantis Hikos paslaugomis.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={6}>
          <li className="c3 li-bullet-0">
            <span className="c2">Jūsų naudojimosi Platforma tikslu</span>
          </li>
        </ol>
        <p className="c16">
          <span className="c10">
            Jūsų naudojimosi Platforma tikslu, tvarkomi šie asmens duomenys:
            vardas, pavardė, el. pašto adresas, telefono numeris, adresas,
            informacija apie laukų, resursų, kultūrų ir narių administravimą,
            jeigu taikoma pagal Jūsų pasirinktą planą: judėjimo (GPS) duomenys.
            Automatiškai yra renkami šie metaduomenys: informacija apie įrenginį
            (įskaitant aparatinės įrangos tipą, operacinę sistemą ir jos versiją
            ir kt.), informacija apie naudojimąsi Platforma (naudojimo dažnumas,
            patirtos problemos ir kt.). Šie asmens duomenys yra tvarkomi
            sutarties vykdymo pagrindu ir saugomi
          </span>
          <span className="c6">&nbsp;</span>
          <span className="c1">
            4 (ketverius) metus nuo Nario Aplinkos uždarymo dienos.
          </span>
        </p>
        <p className="c16">
          <span className="c1">
            Naudodamiesi Platforma, aukščiau nurodomus asmens duomenis, nario,
            agro ir finansinius duomenis savo pasirinkimu galite atskleisti
            kitiems Platformos naudotojams bei valstybės ar savivaldos
            institucijoms. Hikos savo iniciatyva tokių duomenų be Jūsų leidimo
            neperduos kitiems platformos naudotojams ir jokioms institucijoms ar
            įstaigoms. Jūs nusprendžiate, kam ir kokius duomenis atskleisti,
            naudojantis Hikos paslaugomis.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={7}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Komunikacijos su Platformos naudotojais tikslu{' '}
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Hikos Jums gali siųsti informaciją ar pranešimus į Jūsų el. pašto
            adresą, ar informuoti apie juos Platformoje, apie Platformos
            pasikeitimus, atnaujinimus, sutrikimus ir kt. Šiuo tikslu yra
            tvarkomi šie asmens duomenys: vardas, pavardė, el. pašto adresas,
            telefono numeris. Šie asmens duomenys yra tvarkomi sutarties vykdymo
            pagrindu ir saugomi 4 (ketverius) metus nuo Nario Aplinkos uždarymo
            dienos.
          </span>
        </p>
        <p className="c4">
          <span className="c1">
            Jeigu iškilus problemoms ar klausimams kreipiatės į mus dėl
            Platformos veikimo, Jūsų pateiktus asmens duomenis: vardą, pavardę,
            el.&nbsp;pašto adresą ir kitus užklausoje pateikiamus asmens
            duomenis Hikos tvarkys teisėto intereso užtikrinti teikiamų paslaugų
            kokybę pagrindu. Komunikacijos su Platformos Nariais ir Vartotojais
            (klientų aptarnavimo) tikslu asmens duomenys saugomi visą
            komunikacijos laikotarpį ir 1&nbsp;(vienerius) metus po
            komunikacijos pabaigos.
          </span>
        </p>
        <p className="c4">
          <span className="c1">
            Problemų sprendimo tikslu Hikos gali perduoti Jūsų asmens duomenis
            kaip vardas, pavardė, adresas, telefono numeris paslaugų teikėjams,
            kurie gali atvykti į Jūsų ūkį ir išspręsti problemas ar įdiegti
            papildomą įrangą. Apie tai Jūs būsite informuoti.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={8}>
          <li className="c3 li-bullet-0">
            <span className="c2">Mokėjimo už Platformos paslaugas tikslu</span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Mokėjimo už Platformos teikiamas paslaugas tikslu Hikos tvarko šiuos
            asmens duomenis: banko sąskaitos informaciją. Šie asmens duomenys
            yra tvarkomi sutarties ir įstatyminės prievolės (išrašyti sąskaitas)
            pagrindu ir saugomi 10 (dešimt) metų.
          </span>
        </p>
        <p className="c4">
          <span className="c1">
            Mokėjimo vykdymui reikalingi Jūsų duomenys gali būti perduodami
            finansų įstaigai mokėjimo vykdymui užtikrinti.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={9}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Mokymų ir konferencijų organizavimo tikslu
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Hikos organizuoja konferencijas ir mokymus Platformos Nariams apie
            Platformą ir kitas Hikos teikiamas paslaugas. Šiuo tikslu tvarkomi
            šie asmens duomenys: vardas, pavardė, įmonė, el. pašto adresas,
            telefono numeris, atvaizdas (jeigu sutinkate, o renginio metu yra
            filmuojama arba fotografuojama). Šie asmens duomenys yra tvarkomi
            sutarties vykdymo pagrindu ir saugomi 2 (dvejus) metus nuo renginio
            pabaigos. Jeigu sutikote, jūsų atvaizdas bus tvarkomas sutikimo
            pagrindu bei yra saugomas 2 (dvejus) metus nuo renginio dienos.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={10}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Statistinės informacijos apie Platformos naudojimą tikslu
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Hikos norėtų Jus informuoti, kad Hikos turi teisėtą interesą
            panaikinus bet kokias sąsajas su asmeniu ir asmens duomenimis,
            Platformoje esančius duomenis tvarkyti statistikos ir analizės
            tikslais, siekiant pagerinti Platformos funkcionalumą ir kokybę bei
            sukurti naujas paslaugas, laikydamasis teisės aktų reikalavimų.
            Hikos užtikrins, kad tokia veikla netrikdytų Platformos sistemos
            veikimo ir nekeistų tvarkomų asmens duomenų.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={5}>
          <li className="c12 li-bullet-0">
            <span className="c6">
              DALINKITĖS SAVO DUOMENIMIS SU KITAIS PLATFORMOS NARIAIS
            </span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Atkreipkite dėmesį, kad Platforma leidžia Nariams dalintis savo
            duomenimis su kitais Nariais, pavyzdžiui, agronomais, ekspertais,
            konsultantais ir kt. bei valstybės ir savivaldybės institucijomis
            bei įstaigomis. Prieš bendrindami duomenis įsitikinkite, kad
            bendrinimo nustatymai sukonfigūruoti pagal Jūsų pageidavimus. Jei
            dalijatės savo duomenimis su kitais, suteikiate jiems leidimą
            naudoti ir naudotis Jūsų nurodytomis teisėmis į Jūsų Aplinkos
            informaciją ir duomenis, kaip tai leidžia Platformos funkcionalumas.
            Hikos nėra atsakinga už tai, kaip kiti Nariai naudoja Jūsų duomenis,
            arba už patarimus ar informaciją, kurią jie teikia Jums, kai
            dalijatės savo duomenimis.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={6}>
          <li className="c3 li-bullet-0">
            <span className="c2">KAIP TVARKOMI JŪSŲ ASMENS DUOMENYS?</span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Jūsų asmens duomenys bus tvarkomi laikantis Bendrojo duomenų
            apsaugos reglamento (toliau – BDAR), Lietuvos Respublikos asmens
            duomenų teisinės apsaugos įstatymo bei kitų teisės aktų nustatytų
            reikalavimų. Jūsų asmens duomenys tvarkomi atsakingai ir saugiai.
            Hikos, tiek nustatydamas asmens duomenų tvarkymo priemones, tiek
            paties duomenų tvarkymo metu, įgyvendina tinkamas teisės aktuose
            nustatytas duomenų apsaugos technines ir organizacines priemones,
            skirtas apsaugoti tvarkomus asmens duomenis nuo atsitiktinio ar
            neteisėto sunaikinimo, sugadinimo, pakeitimo, praradimo,
            atskleidimo, taip pat nuo bet kokio kito neteisėto tvarkymo.
            Atitinkamos priemonės nustatomos atsižvelgiant į pavojus, kurie kyla
            dėl asmens duomenų tvarkymo.
          </span>
        </p>
        <p className="c5">
          <span className="c1">
            Be Hikos naudojamų duomenų saugumo priemonių ir Jūs turite imtis
            veiksmų užtikrinti tinkamą Jūsų Aplinkos apsaugą. Jūsų Aplinka yra
            apsaugota slaptažodžiu Jūsų privatumui ir saugumui užtikrinti.
            Turite užkirsti kelią neteisėtai prieigai prie savo Aplinkos ir savo
            duomenų, tinkamai pasirinkdami ir apsaugodami slaptažodį bei
            apribodami prieigą prie kompiuterio ar įrenginio ir naršyklės,
            atsijungę, kai baigsite prieigą prie Aplinkos.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={7}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              KAM GALIME ATSKLEISTI JŪSŲ ASMENS DUOMENIS?
            </span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Mes nesidalijame Jūsų asmens duomenimis su jokioms trečiosioms
            šalims, išskyrus atvejus, nurodytus šioje Privatumo politikoje.
          </span>
        </p>
        <p className="c5">
          <span className="c1">
            Laikantis BDAR reikalavimų ir esant teisėtam pagrindui, Mes galime
            atskleisti informaciją apie Jus mūsų darbuotojams, tretiesiems
            asmenims ar duomenų tvarkytojams, kurie turi teisę tvarkyti asmens
            duomenis tik pagal mūsų nurodymus ir tik ta apimtimi ir tiek, kiek
            tai yra būtina.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={8}>
          <li className="c3 li-bullet-0">
            <span className="c2">KOKIOS YRA JŪSŲ TEISĖS? </span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Žemiau pateikiame informaciją apie Jūsų teises, susijusias su Hikos
            vykdomu Jūsų asmens duomenų tvarkymu, ir atvejus, kada šiomis
            teisėmis galite pasinaudoti. Jei norite gauti daugiau informacijos
            apie savo teises ar jas įgyvendinti, susisiekite su mumis šioje
            Privatumo politikoje nurodytu el. pašto adresu.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={11}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Teisė susipažinti su savo asmens duomenimis
            </span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Siekiame, kad Jūs iki galo suprastumėte, kaip mes naudojame Jūsų
            asmens duomenis, ir dėl to nepatirtumėte jokių nepatogumų. Jūs
            galite bet kada susisiekti su mumis ir pasiteirauti, ar mes tvarkome
            kokius nors Jūsų asmens duomenis. Jei mes saugome ar bet kokiu būdu
            naudojame Jūsų asmens duomenis, Jūs turite teisę su jais
            susipažinti. Norėdami tai padaryti, pateikite mums rašytinį prašymą
            šioje Privatumo politikoje nurodytu el. pašto adresu. Mes Jūsų
            prašymo įvykdymo tikslu galime Jūsų paprašyti patvirtinti savo
            asmens tapatybę. Teikdami tokį prašymą, laikykitės sąžiningumo ir
            protingumo principų.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={12}>
          <li className="c3 c28 li-bullet-0">
            <span className="c2">Teisė atšaukti sutikimą</span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Jei esate pateikę mums aiškų sutikimą dėl Jūsų duomenų tvarkymo, jį
            galite bet kada atšaukti šioje Privatumo politikoje nurodytu el.
            pašto adresu.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={13}>
          <li className="c3 li-bullet-0">
            <span className="c2">
              Teisė prašyti suteikti daugiau informacijos
            </span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Tikimės, kad Jūs suprasite, jog aptarti visus įmanomus asmens
            duomenų rinkimo ir naudojimo būdus yra labai sunku. Mes stengiamės
            pateikti kuo aiškesnę ir išsamesnę informaciją bei įsipareigojame
            atnaujinti šią Privatumo politiką, pasikeitus asmens duomenų
            naudojimo procesui. Vis dėlto, jei turite kokių nors klausimų apie
            Jūsų asmens duomenų naudojimą, džiaugsimės galėdami į juos atsakyti
            arba suteiksime visą papildomą informaciją, kurią galime atskleisti.
            Jei turite kokių nors konkrečių klausimų arba nesupratote pateiktos
            informacijos, susisiekite su mumis.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-1" start={14}>
          <li className="c3 li-bullet-0">
            <span className="c2">Papildomos teisės</span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Toliau pateikiame informaciją apie papildomas Jūsų turimas teises,
            kurias galite įgyvendinti laikydamiesi toliau aprašytos tvarkos.
          </span>
        </p>
        <ul className="c0 lst-kix_su25zog6rjh-3 start">
          <li className="c14 li-bullet-0">
            <span className="c1">
              Jūs turite teisę prašyti mūsų ištaisyti bet kokius turimų duomenų
              netikslumus. Tokiu atveju mes galime paprašyti Jūsų patvirtinti
              ištaisytą informaciją.
            </span>
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              Jūs turite teisę prašyti mūsų ištrinti Jūsų asmens duomenis. Ši
              teisė įgyvendinama BDAR 17&nbsp;straipsnyje numatytais atvejais.
            </span>
            <a id="kix.jqyh4kwp2g8b" />
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              Jūs turite teisę prašyti mūsų riboti Jūsų asmens duomenų tvarkymą
              arba jų netvarkyti.
            </span>
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              Jūs turite teisę į duomenų, kurie tvarkomi automatizuotomis
              priemonėmis ir kuriuos iš Jūsų gavome Jums sutinkant arba
              sutarties sudarymo tikslais, perkėlimą. Jums pasinaudojus šia
              teise, Jūsų prašymu perkelsime Jūsų pateiktų duomenų kopiją.
            </span>
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              Jūs turite teisę BDAR 21 str. nustatyta tvarka nesutikti, kad mes
              naudotumėme Jūsų asmens duomenis.
            </span>
          </li>
        </ul>
        <a id="kix.bfym6yjq4c4u" />
        <ol className="c0 lst-kix_su25zog6rjh-0" start={9}>
          <li className="c3 li-bullet-0">
            <span className="c2">KAIP GALITE ĮGYVENDINTI SAVO TEISES?</span>
          </li>
        </ol>
        <p className="c5">
          <span className="c1">
            Siekdami įgyvendinti savo teises, prašymus, skundus ar reikalavimus
            pateikite mums raštu:
          </span>
        </p>
        <ul className="c0 lst-kix_su25zog6rjh-3">
          <li className="c14 li-bullet-0">
            <span className="c10">elektroniniu paštu </span>
            <span className="c7">info@hikos.eu</span>
            <span className="c1">;</span>
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              siunčiant paštu adresu Vito Gerulaičio g. 10-101, LT-08200
              Vilnius;
            </span>
          </li>
          <li className="c14 li-bullet-0">
            <span className="c1">
              atvykus į UAB Hikos, adresu Vito Gerulaičio g. 10-101, LT-08200
              Vilnius.
            </span>
          </li>
        </ul>
        <p className="c5">
          <span className="c1">
            Į gautus prašymus, skundus ar reikalavimus Jums atsakysime raštu
            teisės aktų nustatyta tvarka ir terminais. Stengiamės pateikti Jums
            informaciją kiek įmanoma greičiau, bet ne vėliau kaip per 30 dienų
            nuo Jūsų prašymo gavimo.
          </span>
        </p>
        <p className="c5">
          <span className="c1">
            Jei susisieksite su mumis, mes galime tvarkyti Jūsų mums nurodytus
            duomenis, t. y. vardą, pavardę, el. pašto adresą, telefono numerį,
            datą bei susirašinėjimo tekstą šioje Privatumo Politikoje nurodyta
            tvarka. Prašome atkreipti dėmesį, kad mums gali tekti susisiekti su
            Jumis paštu, el. paštu arba telefonu. Prašome pranešti mums apie
            Jūsų asmens duomenų pasikeitimus.
          </span>
        </p>
        <p className="c5">
          <span className="c1">
            Jeigu, gavus prašymą, skundą ar reikalavimą, mums kils įtarimų dėl
            besikreipiančiojo asmens tapatybės, mes turime teisę paprašyti
            besikreipiančiojo asmens tapatybės dokumento.
          </span>
        </p>
        <a id="kix.plezk97cooyh" />
        <p className="c5">
          <span className="c10">
            Jei mes nesugebėsime suteikti Jums reikiamos informacijos ir (ar)
            turėsite pretenzijų dėl to, kaip yra tvarkomi Jūsų asmens duomenys,
            Jūs turite teisę kreiptis į Valstybinę duomenų apsaugos inspekciją (
          </span>
          <span className="c10 c18">
            <a
              className="c30"
              href="https://www.google.com/url?q=http://www.vdai.lrv.lt&sa=D&source=editors&ust=1651664531075653&usg=AOvVaw1FOwZGDrT9_KWAxZeQAKXt"
            >
              www.vdai.lrv.lt
            </a>
          </span>
          <span className="c1">), pateikdami skundą.</span>
          <a id="kix.m1ti4f65q0i" />
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={10}>
          <li className="c3 li-bullet-0">
            <span className="c2">ATSAKOMYBĖ</span>
          </li>
        </ol>
        <p className="c5" id="h.2et92p0">
          <span className="c1">
            Jūs esate atsakingi už tai, kad Jūsų mums pateikti duomenys būtų
            tikslūs, teisingi ir išsamūs. Jeigu pasikeičia Jūsų pateikti
            duomenys, Jūs turite nedelsdami mus apie tai informuoti el. paštu.
            Mes jokiu atveju nebūsime atsakingi už žalą, atsiradusią Jums dėl
            to, jog Jūs nurodėte neteisingus ar neišsamius asmens duomenis arba
            neinformavote mūsų jiems pasikeitus.
          </span>
        </p>
        <ol className="c0 lst-kix_su25zog6rjh-0" start={11}>
          <li className="c3 li-bullet-0">
            <span className="c2">PRIVATUMO POLITIKOS PAKEITIMAI</span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            Mes galime kartas nuo karto keisti šią Privatumo politiką. Apie tokį
            pakeitimą Jus informuosime iš anksto, prieš 15&nbsp;(penkiolika)
            kalendorinių dienų iki pakeitimų įsigaliojimo, kad turėtumėte
            galimybę susipažinti su atnaujinta Privatumo politika ir nuspręsti
            dėl tolimesnio naudojimosi Platforma ar Aplinkos uždarymo. Naujausia
            (aktuali) Privatumo politikos versija visada bus matoma ir
            pasiekiama Platformoje.
          </span>
        </p>
        <p className="c5">
          <span className="c1">
            Apačioje nurodyta „Atnaujinimo data“ rodo, kada Privatumo politika
            atnaujinta paskutinį kartą.
          </span>
        </p>
        <p className="c5">
          <span className="c10">Atnaujinimo data: 2022-05-03</span>
        </p>
        <hr className="c23" />
        <div>
          <p className="c29">
            <a href="#ftnt_ref1" id="ftnt1">
              [1]
            </a>
            <span className="c10 c25">&nbsp;</span>
            <span className="c7">
              Kaip apibrėžta Lietuvos Respublikos Vartotojų teisių apsaugos
              įstatyme.
            </span>
            <span className="c10 c20">&nbsp;</span>
          </p>
        </div>
      </div>
    </StyledPolicy>
  );
};

export default PrivacyPolicyText;
